import { useQuery } from '@tanstack/react-query';
import { fetchWorkingHours } from '@apis/working-hours';

const WORKING_HOURS_STALE_MS = 30 * 60_000;

/**
 * A site's working hours (Trusstor project calendar). The schedule changes
 * rarely, so it is cached for half an hour; every caller shares the one
 * `['working-hours', siteId]` entry. `enabled` lets a caller hold the fetch
 * back (a fallback source) — it is always off without a `siteId`.
 */
export function useWorkingHours(siteId: string | undefined, enabled = true) {
  return useQuery({
    queryKey: ['working-hours', siteId],
    queryFn: ({ signal }) => fetchWorkingHours(siteId!, signal),
    enabled: enabled && !!siteId,
    staleTime: WORKING_HOURS_STALE_MS,
  });
}
